import StarDetailPage from '@pages/emporium/star/detail'
import type { NextPage } from 'next'

const StarFavoriteDetailPage: NextPage<Props> = () => {
  return <StarDetailPage />
}

type Props = {}

export default StarFavoriteDetailPage
